import {TransferType} from '@transactions/graphql';
import type {BindingKey} from 'common/bindings';

/**
 * A preset for the Create inverse modal: a one-click recipe that fills the
 * form for a recurring counterpart flow ("ATM withdrawal → Cash"). Presets
 * are code-owned, like the binding registry they lean on — the entity a
 * preset targets is never named here, only the binding slot that remembers
 * it, so adding a preset costs a registry entry and no new UI surface.
 */
export type InversePreset = {
  key: string;
  label: string;
  /** The binding slot naming the target account (see common/bindings.ts). */
  accountBinding: BindingKey;
  /** Description prefilled on the inverse row. */
  description: string;
  /** Transfer type used when the preset combines the rows into a transfer. */
  transferType: TransferType;
  /**
   * Whether the preset makes sense for a selection with this net amount
   * (e.g. cash arrives only when the selection is a net outflow).
   */
  appliesTo: (netAmount: number) => boolean;
};

export const INVERSE_PRESETS: InversePreset[] = [
  {
    key: 'atmWithdrawal',
    label: 'ATM withdrawal',
    accountBinding: 'cashAccount',
    description: 'ATM withdrawal',
    transferType: TransferType.AccountTransfer,
    appliesTo: (netAmount) => netAmount < 0,
  },
];
